const MergedTableHeader = ({ headers, textCenter }) => {

    if (!headers || headers.length === 0) return null;

    const singleRow = !Array.isArray(headers[0]);

    const headerRows = singleRow ? [headers] : headers;
    const rows = headerRows.length;
    const cols = headerRows[0].length;

    const skip = Array.from({ length: rows }, () => Array(cols).fill(false));

    const getSpans = (r, c) => {
        if (skip[r][c]) return null;

        const cellValue = headerRows[r][c];
        let rowspan = 1;
        let colspan = 1;

        // 단일행
        for (let i = c + 1; i < cols; i++) {
            if (headerRows[r][i] === cellValue) {
                colspan++;
                skip[r][i] = true;
            } else {
                break;
            }
        }

        // 다중행
        if (!singleRow) {
            for (let i = r + 1; i < rows; i++) {
                let same = true;
                for (let j = 0; j < colspan; j++) {
                    if (headerRows[i][c + j] !== cellValue) {
                        same = false;
                        break;
                    }
                }
                if (same) {
                    for (let j = 0; j < colspan; j++) {
                        skip[i][c + j] = true;
                    }
                    rowspan++;
                } else {
                    break;
                }
            }
        }

        return { rowspan, colspan, value: cellValue };
    };

    return (
        <thead>
            {headerRows.map((row, rIdx) => (
                <tr key={rIdx}>
                    {row.map((col, cIdx) => {
                        if (skip[rIdx][cIdx]) return null;
                        const span = getSpans(rIdx, cIdx);
                        if (!span) return null;
                        const { rowspan, colspan, value } = span;
                        return (
                            <th className={`border-b-1 ${textCenter ? 'text-center' : ''}`}
                                key={`${rIdx}-${cIdx}`}
                                rowSpan={rowspan > 1 ? rowspan : 1}
                                colSpan={colspan > 1 ? colspan : 1}
                            >
                                {value}
                            </th>
                        );
                    })}
                </tr>
            ))}
        </thead>
    );
};

export default MergedTableHeader;
